import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useInstitucionalService() {
    const { authenticatedFetch, authenticatedFormFetch } = useApi();

    // Atualiza descrição e/ou vídeo de um conteúdo institucional (tipo: 'sante' ou 'livro')
    const atualizarInstitucional = async (formData) => {
        const response = await authenticatedFormFetch(URLS.UPDATE_INSTITUCIONAL, formData);
        return response.json();
    };

    // Lista todos os registros (útil para debug ou tela geral)
    const listarTodosInstitucionais = async () => {
        const response = await authenticatedFetch(URLS.READ_ALL_INSTITUCIONAL, {
            method: 'POST',
        });
        return response.json();
    };

    return {
        atualizarInstitucional,
        listarTodosInstitucionais,
    };
}